import { PricingLandingData } from "../queries/pricingLandingQuery";
import { LinkTo } from "./linkTo";

export type QuestionsProps = {
  moduleInfo: Pick<PricingLandingData, "moduleQuestions">;
};

export function Questions(props: QuestionsProps) {
  const moduleInfo = props.moduleInfo.moduleQuestions.moduleInput;

  return (
    <>
      <h2 className="text-head-3 text-center text-white">
        <em>{moduleInfo.heading}</em>
      </h2>
      <p className="text-body-1 mt-8 text-center text-white">
        {moduleInfo.subHeading}
      </p>
      <div className="flex justify-center">
        <div className="flex w-full max-w-[600px] flex-wrap justify-center md:justify-around">
          {moduleInfo.cta1URL && (
            <LinkTo.External
              buttonStyle="primary"
              buttonColor="teal"
              url={moduleInfo.cta1URL}
              style="button"
              className="mt-10 w-[250px]"
            >
              {moduleInfo.cta1Text}
            </LinkTo.External>
          )}
          {moduleInfo.cta2URL && (
            <LinkTo.External
              buttonStyle="secondary"
              buttonColor="teal"
              url={moduleInfo.cta2URL}
              style="button"
              className="mt-10 w-[250px] bg-white text-black"
            >
              {moduleInfo.cta2Text}
            </LinkTo.External>
          )}
        </div>
      </div>
      {moduleInfo.image && (
        <div
          className="h-[120px] w-full bg-[bottom_right_-0px] bg-no-repeat"
          style={{
            backgroundImage: `url(/questions_graphic.svg)`,
          }}
        ></div>
      )}
    </>
  );
}

export default Questions;
